import {ApiPerson, ApiPersonalProfileBaseWithPhoto} from "../../model/rest/rest-model";
import {Person, PersonDetails} from "../../model/rest/casa-apiv2.model";

export class PersonNameExtractor {
    public static getPersonName(person: ApiPerson<ApiPersonalProfileBaseWithPhoto>) {
        if (!person) {return ''; }
        const nameComponents: string[] = [];
        if (person.personalProfile) {
            if (person.personalProfile.name) {
                nameComponents.push(person.personalProfile.name);
            }
            if (person.personalProfile.surname) {
                nameComponents.push(person.personalProfile.surname);
            }
        } else {
            if (person.name) {
                nameComponents.push(person.name);
            }
            if (person.surname) {
                nameComponents.push(person.surname);
            }
        }
        return nameComponents.join(' ');
    }

  static getCasaPersonName<T extends PersonDetails>(person: Person<T>) {
    if (!person) return '';
    const nameComponents: string[] = [];
    if (person.details.name) {
      nameComponents.push(person.details.name);
    }
    if (person.details.surname) {
      nameComponents.push(person.details.surname);
    }
    return nameComponents.join(" ");
  }

}
